export default __webpack_public_path__ + "static/media/3illustration.dfe2e15b.png";